export default __webpack_public_path__ + "static/media/cooperation.c1f2c458.png";